import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  @Input() public ring1 : string;
  @Input() public ring2 : string;
  @Input() public ring3 : string;
  constructor() { }

  ngOnInit() {
  }

}
